__turbopack_context__.v({
  "frame": "SmartImage-module-scss-module__VODV4q__frame",
  "img": "SmartImage-module-scss-module__VODV4q__img",
  "imgLoaded": "SmartImage-module-scss-module__VODV4q__imgLoaded",
  "missing": "SmartImage-module-scss-module__VODV4q__missing",
  "shimmer": "SmartImage-module-scss-module__VODV4q__shimmer",
  "skeleton": "SmartImage-module-scss-module__VODV4q__skeleton",
});
